<template>
    <div class="index">
      <div class="main" @click="getProductsSale">
        <ul class="topBar">
          <li>订单统计</li>
          <el-button @click="showFlag = true" class="shouquan" >授权</el-button>
          <div class="dial-header">
            <!-- 授权弹框 -->
            <el-dialog title="选择产品" :visible.sync="showFlag" 
              class=" choosePro" @close="closeFlag">
              <img src="../assets/img/erweima.png" @click="showSingle = true">
              <div @click="placeOrder">
                <ul class="top">
                  <li v-for="(item,index) in list" v-on:click="choose(index)" value="" :class="{active:index==current}" :key="index">{{item.productname}}</li>
                </ul>
                <div class="search">
                  <span>选择账号</span>
                  <form onsubmit="return false;">
                    <input type="text" @keydown="getBuyUser($event)" class="sbtn"/>
                    <input  type="button" @click="getBuyUser">
                     <p style="display:none;color:red" class="warn">请输入账号</p>
                  </form>
                </div>
                <ul class="name" style="visibility:hidden">
                  <li>
                    <span><img class="userPhoto"/></span>
                    <i class="userNickName"></i>
                  </li>
                  <li>
                    <i>圈号：</i>
                    <i class="userNum"></i>
                  </li>
                </ul>
                <div class="bottom">
                  <p>销售价格</p>
                  <span class="proPrice"></span> 
                  <el-button @click="showFlag = false" :plain="true"><div @click="showPay = true">支付</div></el-button>
                </div>
               </div>
            </el-dialog>                 
          </div>
          <!-- 单次授权弹框 -->
          <div class="dial-headers">
            <el-dialog title="单次授权" :visible.sync="showSingle">
              <div>
                <ul class="names">
                  <li>
                    <span></span>
                    <i>ABC</i>
                  </li>
                  <li>
                    <i>圈号：</i>
                    <i>192099739</i>
                  </li>
                </ul>
                <div class="pay">
                  <p>收款码</p>
                  <img src="../assets/img/erweima2.png">
                  <p><button>直接授权</button></p>
                </div>
              </div>
            </el-dialog>
          </div>
          <!-- 支付弹框 --> 
          <div class="dial-header" id="pay">
            <el-dialog :visible.sync="showPay" @close="closePay">
              <div>
                <div class="top">
                  <img src="../assets/img/weixin.png">
                  <span>扫码完成微信支付</span>
                </div>
                <div class="middle">
                  <span class="payCode"></span>
                </div>
                <p><button @click="showPay = false" :plain="true"><div @click="authorizationPay">直接授权</div></button></p>
              </div>
            </el-dialog>
          </div>  
        </ul>
      </div>
        <div class="icome" @click="getOrderCount">
          <ul class="order">
            <li>
              <div><i>￥</i><span class="day">0</span></div>
              <p>销售额</p>
            </li>
            <li>
              <div><i>￥</i><span class="month">0</span></div>
              <p>当月销售额</p>
            </li>
            <li>
              <div><span class="orders">0</span></div>
              <p>完成订单</p>
            </li>
            <li>
              <div><i>￥</i><span class="all">0</span></div>
              <p>累计销售额</p>
            </li>
          </ul>
        </div>
        <div class="common" @click="getSaleUserInfo">
          <div class="commonSty">
            <div class="commonTop">
              <img src="../assets/img/gift.png">
              <span>礼物收入</span>
            </div>
            <div class="commonCon">
              <span>昨天：</span><i class="giftIncomeYest">0</i><span>元</span>
              <span>累计：</span><i class="giftIncome">0</i><span>元</span>
            </div>
          </div>
          <div class="commonSty">
            <div class="commonTop">
              <img src="../assets/img/sales.png">
              <span>销售账号活动</span>
            </div>
            <div class="commonCon">
              <span>举办：</span><i class="holdcount">0</i><span>场</span>
              <span>参与：</span><i class="joincount">0</i><span>场</span>
            </div>
          </div>
        </div>
        <div id="echarts">
            <div id="myChart">
              <!-- 柱形图 -->
              <div id="chartColumn" style="width:7.79rem; height:4.39rem;"></div> 
              <!-- 饼图 -->
              <div id="chartPie" style="width:7.79rem; height:4.39rem;"></div>
              <!--<div class="progress">
                  <p>产品销量</p>
                  <div>
                    <span>单场</span>
                    <el-progress :percentage="70" color="#FD9889" :text-inside="true" :stroke-width="38" style="width:6.79rem;float:left;" ></el-progress>
                  </div>
                  <div>
                    <span>10场</span>
                    <el-progress :percentage="70" color="#F5CA60":text-inside="true" :stroke-width="38" style="width:6.79rem;float:left;"></el-progress>
                  </div>
                  <div>
                    <span>年费</span>
                    <el-progress :percentage="70" color="#4EAAFF":text-inside="true" :stroke-width="38" style="width:6.79rem;float:left;"></el-progress>
                  </div>
                  <div>
                    <span>高级年费</span>
                    <el-progress :percentage="70" color="#8173FA" :text-inside="true" :stroke-width="38" style="width:6.79rem;float:left;"></el-progress>
                  </div>
                </div>  -->
            </div>
        </div>     
    </div>
</template>

<script>
  import echarts from 'echarts'
  import axios from 'axios'
  import $ from 'jquery'
  import {delCookie,getCookie,setCookie} from '@/util/util'
  import "../assets/js/jquery.qrcode.min.js"

  export default {
    name:'dial-headerss',
    data(){
      return{
        showFlag: false,
        showSingle: false,
        showPay: false,
        chartColumn: null,
        chartPie: null,
        btnDisabled:false,
        btnText:'50',
        list:[],
        listName:[],
        listId:[],
        listPrice:[],
        current:-1
      }
    },
    created(){
      this.getOrderCount();
      this.getSaleUserInfo();
      this.getBuyUser();
      this.placeOrder();
      // this.authorizationPay();
      this.getProductsSale() 
    },
    methods:{
      //清空授权框 
      closeFlag(){
        $(".sbtn").val("");
        $(".userNum").text("");
        $(".userNickName").text("");
        $(".userPhoto").removeAttr("src");
        $('.name').css('visibility','hidden');
        $('.top>li').removeClass("active");
        $('.proPrice').text("");
        $('.payCode').text("");
      },
      // 清空支付框
      closePay(){
        $('.payCode').text("");
        $(".sbtn").val("");
        $(".userNum").text("");
        $(".userNickName").text("");
        $(".userPhoto").removeAttr("src");
        $('.name').css('visibility','hidden');
        $('.top>li').removeClass("active");
        $('.proPrice').text("");
        delCookie('productId');
        delCookie('salePrice');
        delCookie('outTradeNo');
      },
      // 点击事件
      choose:function(index){
        this.current=index;
        this.productname=this.list[index].productname;
        this.id = this.list[index].id;
        this.costprice = this.list[index].costprice;
        $('.proPrice').text("￥"+this.costprice);
        let expireDays = 1000 * 60 * 60 ;
        // 获取id
        setCookie('productId',this.id,expireDays);
        // 获取出售价格
        setCookie('salePrice',this.costprice,expireDays);
      },
      // 键盘事件
      getBuyUser(ev){
        if(ev.keyCode == 13) {  //键盘回车的编码是13
          this.getBuyUser();
        }
      },
      // 根据友友号搜索用户信息
      getBuyUser:function(){
        // input里面的值
        var btn=$(".sbtn").val();
        var userNum=$(".userNum");
        var NickName=$(".userNickName");
        var Photo=$(".userPhoto");
        axios.get("/scene/buyUser",{
           params:{
            userNum:btn
          }
        }).then(res => {
          $('.userNum').html(res.data.data.userNum); 
          $('.userNickName').html(res.data.data.userNickName);
          $('.userPhoto').attr('src',res.data.data.userPhoto);
          if(res.data.retCode==200){
            $('.name').css('visibility','visible');
            let expireDays = 1000 * 60 * 60 ;
          }else{
            $('.name').css('visibility','hidden');
            $('.warn').css("display","block");
          }
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 销售产品下单
      placeOrder:function(){ 
        const url ='/scene/placeOrder';
        var params = new URLSearchParams();
        params.append('token', getCookie('session'));       
        params.append('userNum', getCookie('userNum'));
        params.append('productId', getCookie('productId'));
        params.append('salePrice', getCookie('salePrice'));
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          $('.payCode').qrcode(res.data.data.codeUrl);
          console.log(res)
          let expireDays = 1000 * 60 * 60 ;
          // 获取订单编码
          setCookie('outTradeNo',res.data.data.outTradeNo,expireDays);
          if(res.data.retCode==400){
            this.$message.error(res.data.retDesc);
          }
          if(res.data.retCode==406){
            this.$message.error(res.data.retDesc);
          }
        });
      },
      // 授权支付
      authorizationPay:function(){ 
        const url ='/scene/authorizationPay';
        var params = new URLSearchParams();
        params.append('outTradeNo', getCookie('outTradeNo'));
        this.$axios({
          method: 'post',
          url:url,
          data:params
        }).then((res)=>{
          this.data=res.data;
          console.log(res.data)
          if(res.data.retCode==400){
            this.$message.error(res.data.retDesc);
          }
          if(res.data.retCode==200){
            this.$message.success(res.data.retDesc);
          }
        });
      },
      // 订单统计
      getOrderCount:function(){
        axios.get("/scene/orderCount",{
          params:{
            token:getCookie('session'),
            userType:'1'
          }
        }).then(res => {
            this.data = res.data;
            var daySales=this.data.data.daySales;
            var day=$('.day').html(daySales);
            var monthSales=this.data.data.monthSales;
            var month=$('.month').html(monthSales);
            var orderCount=this.data.data.orderCount;
            var orders=$('.orders').html(orderCount);
            var allSales=this.data.data.allSales;
            var all=$('.all').html(allSales);
          }).catch((err)=>{
            console.log(err);
          })
      },
      // 礼物收入、销售账号活动
      getSaleUserInfo:function(){
        axios.get("/scene/saleUserInfo",{
          params:{
            token:getCookie('session'),
            userType:'1'
          }
        }).then(res => {
          this.data = res.data;
          var giftIncomeYest=this.data.data.giftIncomeYest;
          var IncomeYest=$('.giftIncomeYest').html(giftIncomeYest);
          var giftIncome=this.data.data.giftIncome;
          var Income=$('.giftIncome').html(giftIncome);
          var joincount=this.data.data.holdAndJoinCount.joincount;
          var join=$('.joincount').html(joincount);
          var holdcount=this.data.data.holdAndJoinCount.holdcount;
          var hold=$('.holdcount').html(holdcount);
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 获取出售的产品
      getProductsSale:function(){
        axios.get("/scene/productsSale",{
        }).then(res => {
          // 获取产品名和id
          var list=res.data.data;
          this.list = res.data.data;
          // 遍历循环产品名
          var listName=[];
          for(var i=0;i<list.length;i++){
            var productname=list[i].productname;
            listName.push(productname);
          };
          // 遍历循环产品id
          var listId=[];
          for(var i=0;i<list.length;i++){
            var id=list[i].id;
            listId.push(id);
          }
          // 遍历循环产品价格
          var listPrice=[];
          for(var i=0;i<list.length;i++){
            var price=list[i].costprice;
            listPrice.push(price);
          }
        }).catch((err)=>{
          console.log(err);
        })
      },
      // 柱状图
      drawColumnChart() {
        // 订单销量按月统计
        axios.get("/scene/orderMonthCount",{
          params:{
          token:getCookie('session'),
          userType:'1'
        }
        }).then(res => {
          var newData=res.data.data;
          // console.log(newData);
          this.chartColumn = echarts.init(document.getElementById('chartColumn'));
          this.chartColumn.setOption({
            title: { text: '销量图表'},
              // color: ['#FFEBEB'],
              tooltip : {
                axisPointer : {            
                //坐标轴指示器，坐标轴触发有效
                  type : 'shadow'        
                  //默认为直线，可选为：'line' | 'shadow'
                },  
              },
              xAxis: {
                type: 'category',
                data: ["一月", "二月", "三月", "四月", "五月", "六月","七月","八月","九月","十月","十一月","十二月"],
                axisTick: {
                  alignWithLabel: true
                }
              },
              yAxis: {
                type:'value'
              },
              series: [{
                name: '销量',
                type: 'bar',
                data: newData,
                }]
              });
        }).catch((err)=>{
          console.log(err);
        })
      },      
      // 饼图
      drawPieChart(){
        // 产品销量统计
        axios.get("/scene/productOrderCount",{
          params:{
            token:getCookie('session')
          }
          }).then(res => {
            var newData=res.data.data;
            // console.log(newData);
            this.chartPie = echarts.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
              title: {
                  text: '产品销量',
                  x: 'center'
              },
              tooltip: {
                  trigger: 'item',
                  formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                orient: 'vertical',
                x: 'left',
                data:['单场','十场','年费','高级年费']
              },
              series: [
                  {
                    name: '访问来源',
                    type: 'pie',
                    radius: '65%',
                    center: ['50%', '60%'],
                      label: {
                        normal: {
                            formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 28
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        }
                      },
                    data:newData
                }
              ]
            });
            }).catch((err)=>{
              console.log(err);
            })
        },
        drawCharts() {
          this.drawColumnChart()
          this.drawPieChart() 
        },
      },
      mounted: function () {
        this.drawCharts()
      },
      updated: function () {
        this.drawCharts()
      }
    }      
</script>

<style scoped lang="scss">
  #pay .el-dialog{
    width: 4.76rem;
    height: 5.64rem;
    margin: 2.79rem 0 0 7.87rem;
    border-radius:0.12rem;
  }
  #pay .el-dialog__header{
    padding-top: 0;
  }
  #pay .el-dialog__body{
    padding: 0;
  }
  #pay .top{
    float: left;
    width: 4.76rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center; 
    margin: 0.44rem 0 0.44rem 0;
  }
  #pay .middle{
    width: 4.76rem;
    height: 3.75rem;
    text-align: center;
    float: left;
  }
  #chartPie{
    float: left;
    margin-left: 0.21rem;
  }
  #chartColumn{
    float: left;
  }
  .main{
    background:rgba(246,246,246,1);
    width: 15.6rem;
  }
  .main>.topBar>li{
    height:0.23rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    float: left;
  }
  .icome>.order{
    float: left;
    margin-top: 0.15rem;
  }
  .icome>.order>li{
    float: left;
    margin-left: -0.1rem;
    width: 3.73rem;
    height: 1.89rem;
    margin-right: 0.4rem;
  }
  .icome>.order>li:nth-of-type(1){
    background: url("../assets/img/day.png") no-repeat;
    background-size: 3.73rem 1.89rem;
    width: 3.73rem;
    height: 1.89rem;
  }
  .icome>.order>li:nth-of-type(2){
    background: url("../assets/img/month.png") no-repeat;
    background-size: 3.73rem 1.89rem;
    width: 3.73rem;
    height: 1.89rem;
  }
  .icome>.order>li:nth-of-type(3){
    background: url("../assets/img/order.png") no-repeat;
    background-size: 3.73rem 1.89rem;
    width: 3.73rem;
    height: 1.89rem;
  }
  .icome>.order>li:nth-of-type(4){
    background: url("../assets/img/income.png") no-repeat;
    background-size: 3.73rem 1.89rem;
    width: 3.73rem;
    height: 1.89rem;
    margin-right: 0;
  }
  .icome>.order>li>div{
    display:block;
    height:0.48rem;
    font-size:0.48rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
  }

  .icome>.order>li>p{
    height:0.16rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(254,254,254,1);
    text-align: center;
  }
  .common{
    float: left;
    margin-top: 0.3rem;
  }
  .common>.commonSty{
    width: 7.7rem;
    height: 2.35rem;
    background: url("../assets/img/giftIncome.png");
    background-size: 7.7rem 2.35rem;
    float: left;
  }
  .common .commonTop{
    width: 7.7rem;
    height: 0.8rem;
  }
  .common .commonTop>img{
    width: 0.76rem;
    height: 0.76rem;
    margin: 0.04rem 0.13rem 0 0.16rem;
    float: left;
  }
  .common .commonTop>span{
    display: block;
    float: left;
    height:0.35rem;
    font-size:0.36rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(71,71,71,1);
    line-height:0.35rem;
    margin-top: 0.31rem;
  }
  .common .commonCon{
    float: left;
    height: 0.38rem;
    line-height: 0.38rem;
    margin: 0.24rem 0 0 1.06rem;
  }
  .common .commonCon>span{
    height:0.23rem;
    line-height: 0.38rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(71,71,71,1);
    float: left;
  }
  .common .commonCon>i{
    display: inline-block;
    text-align: center;
    height:0.38rem;
    font-size:0.48rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(71,71,71,1);
    float: left;
    margin: 0 0.3rem 0 0.3rem;
  }
  .common .commonCon>span:nth-of-type(3){
    margin-left: 0.91rem;
  }
  .common>div:nth-of-type(2){
    margin-left: 0.26rem;
    background: url("../assets/img/salesAccount.png");
    width: 7.7rem;
    height: 2.35rem;
    background-size: 7.7rem 2.35rem;
  }
  .common>div:nth-of-type(2) img{
    margin: 0.07rem 0.17rem 0 0.17rem;
  }
  .top{
   float: left;
   margin: 0 0.05rem 0.15rem 0.21rem;
  }
  .top>li{
    background:url('../assets/img/bg2.png') no-repeat;
    background-size: 1.05rem 0.65rem;
    width: 1.05rem;
    height: 0.65rem;
    float: left;
    font-size:0.18rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(244,57,65,1);
    line-height:0.65rem;
    text-align: center;
    cursor: pointer;
  }
  .top>.active{
    background:url('../assets/img/bg1.png') no-repeat;
    background-size: 1.05rem 0.65rem;
    color: #fff;
  }
  .search{
    float: left;
  }
  .search>span{
    height:0.2rem;
    font-size:0.2rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.2rem;
    margin: 0 0 0 0.28rem;
  }
  .search>form{
    width: 3.3rem;
    height: 0.4rem;
    border:0.01rem solid rgba(191,191,191,1);
    border-radius:0.08rem;
    margin: 0.17rem 0 0 0.73rem;
  }
  .search>form input[type='text']{
    margin-left:0.04rem;
    width:2.9rem;
    height:0.3rem;
    vertical-align: top;
    text-indent: 0.09rem;
    margin-top: 0.04rem;
  }
  .search>form input[type='button']{
    width: 0.25rem;
    height: 0.25rem;
    background: url('../assets/img/search.png');
    background-size: 0.25rem 0.25rem;
    margin-top: 0.06rem;
    margin-left: -0.09rem;
  }
  .name{
    float: left;
    width: 4.76rem;
    height: 0.94rem;
  }
  .name>li{
    float: left;
  }
  .name>li>span{
    display: block;
    width:0.49rem;
    height:0.49rem;
    border-radius:50%;
    float: left;
    margin: 0.24rem 0.11rem 0.21rem 0.8rem;
  }
  .name>li>span>img{
    width:0.49rem;
    height:0.49rem;
    border-radius:50%;
  }
  .name>li>i{
    display: block;
    float: left;
    height:0.16rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.16rem;
    overflow: hidden;
  }
  .name>li:nth-of-type(1)>i{
    width: 1.5rem;
    margin: 0.41rem 0 0.4rem 0;
  }
  .name>li:nth-of-type(2){
    margin-top: 0.41rem;
    margin-bottom: 0.4rem;
  }
  .bottom{
    float: left;
    width: 4.76rem;
    border-top:0.01rem solid rgba(191, 191, 191, 1);
  }
  .bottom>p{
    height:0.2rem;
    font-size:0.2rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    margin: 0.23rem 0 0.27rem 0.29rem;
  }
  .bottom>span{
    height:0.36rem;
    font-size:0.36rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.36rem;
    margin: 0 1.71rem 0 1.71rem;
  }
  .names{
    float: left;
    width: 4.76rem;
    height: 0.94rem;
    border-bottom:0.01rem solid rgba(191, 191, 191, 1);
    margin-bottom: 0.23rem;
  }
  .names>li{
    float: left;
  }
  .names>li>span{
    display: block;
    width:0.49rem;
    height:0.49rem;
    background:rgba(81,187,246,1);
    border-radius:50%;
    float: left;
    margin: 0.24rem 0.11rem 0.21rem 0.97rem;
  }
  .names>li>i{
    display: block;
    float: left;
    height:0.16rem;
    font-size:0.16rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.16rem;
  }
  .names>li:nth-of-type(1)>i{
    margin: 0.41rem 0.83rem 0.4rem 0;
  }
  .names>li:nth-of-type(2){
    margin-top: 0.41rem;
    margin-bottom: 0.4rem;
  }
  .pay{
    width: 4.75rem;
    text-align: center;
  }
  .pay>p{
    height:0.24rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.24rem;
  }
  .pay>img{
    margin-top: 0.36rem;
    width: 2.52rem;
    height: 2.52rem;
  }
  .pay>p>button{
    width:1.13rem;
    height:0.40rem;
    background:rgba(244,57,65,1);
    border-radius:0.20rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    float: right;
    margin: 0.26rem 0.29rem 0 0;
  }
  #pay p>button{
    width:1.13rem;
    height:0.40rem;
    background:rgba(244,57,65,1);
    border-radius:0.20rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    float: right;
    margin: 0.26rem 0.29rem 0 0;
  }
</style>
<style lang="scss">
  .el-dialog__headerbtn .el-dialog__close{
    display: none;
  }
  element.style {
    margin-top: 0; 
  }
  .index .el-dialog{
    width: 4.76rem;
    height: 5.41rem;
    margin: 2.79rem 0 0 7.87rem;
    border-radius: 0.12rem;
  }
  #pay .el-dialog{
    width: 4.76rem;
    height: 6rem;
    margin: 2.79rem 0 0 7.87rem;
    border-radius: 0.12rem;
  }
  .index .el-dialog__header{
    padding:0;
    position: relative;
  }
  .index .choosePro .el-dialog__header{
    padding:0;
    padding-top: 0.3rem;
    position: relative;
  }
  .index .el-dialog__headerbtn{
    top: 0;
    right: 0;
  }
  .index .el-dialog__title{
    height:0.2rem;
    font-size:0.2rem;
    font-family:STHeitiSC-Light;
    font-weight:300;
    color:rgba(22,22,22,1);
    line-height:0.2rem;
    margin: 0 0 0 0.28rem;
  }
  .index  .el-dialog__body{
    padding: 0;
  }
  .index .choosePro .el-dialog__body{
    padding: 0.22rem 0 0 0 ;
  }
  .index  .el-dialog__body>img{
    width: 0.25rem;
    height: 0.25rem;
    position: absolute;
    left: 4rem;
    top: 0.3rem;
  }
 .index  .el-button{
  padding: 0;
 }
  .index .bottom>.el-button{
    letter-spacing: 0.1rem;
    width:2.27rem;
    height:0.44rem;
    background:rgba(244,57,65,1);
    border-radius:0.22rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    margin-top: 0.3rem;
    margin-left: 1.25rem;
  }
 
  .shouquan{
    width:0.93rem;
    height:0.31rem;
    background:rgba(244,57,65,1);
    border:0.01rem solid rgba(244,57,65,1);
    border-radius:0.16rem;
    font-size:0.18rem;
    font-family:STHeitiSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    float: right;
  }
  #chartColumn>div{
    background-color: #fff;
  }
  #chartPie>div{
    background-color: #fff;
  }
  .index .dial-headers .el-dialog{
    width: 4.75rem;
    height: 5.44rem;
    margin: 2.79rem 0 0 7.87rem;
    border-radius:0.12rem;
  }
  .index .dial-headers .el-dialog__header{
    padding-top: 0.28rem;
  }
  .index .dial-headers .el-dialog__body{
    padding: 0.01rem 0 0 0 ;
  }
  .index .dial-headers .el-buttom{
    border-color: #f43941;
  }
  .el-button{
  padding:0;
  border:0;
  }
  #chartColumn{
    float: left;
  }
  #myChart .progress{
    width: 7.71rem;
    height: 4.39rem;
    background: #fff;
    float: left;
  }
  #myChart .progress>p{
    height:0.23rem;
    font-size:0.24rem;
    font-family:STHeitiSC-Light;
    font-weight:bold;
    color:rgba(22,22,22,1);
    margin: 0.29rem 0 0 0.18rem;
  }
  .el-button:active{
    color:rgba(244,57,65,1);
    border-color:rgba(244,57,65,1);
  }
  .el-button:focus, .el-button:hover{
    color:#fff;
    border-color:rgba(244,57,65,1);
    background: rgba(244,57,65,1);
  }
</style>


// WEBPACK FOOTER //
// src/views/index.vue